import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getSelectionCriteria } from '../redux/selectors/SelectionCriteriaWizardSelectors';
import SelectionCriteriaDto from '../../../report/common/models/SelectionCriteriaDto';
import { reportClearData, reportLoadData } from '../../../report/common/redux/actions/ReportsActions';
import ReportDefinitions from '../../../common/config/ReportDefinitions';
import { wizardRoutes } from '../Routes/WizardRoutes';
import { localizedPushHistory } from '../../../../core/modules/common/tools/HistoryTools';
import { dayPeriodSelected } from '../../period-selector/redux/actions/PeriodSelectionActions';

export class ReportNavigationLink extends Component {
  navigate(reportId, date) {
    const report = ReportDefinitions[reportId];
    const { selectionCriteria } = this.props;
    if (date) {
      const period = {
        ...this.props.selectionCriteria.period,
        startDate: moment(date).toDate(),
        endDate: moment(date).toDate(),
        dayPicker: {
          startDate: new Date(date),
          endDate: new Date(date),
        },
      };
      this.props.dayPeriodSelected(period);
    }
    this.props.reportLoadData(
      report,
      null,
      new SelectionCriteriaDto(selectionCriteria, report.selectionCriteria.items),
    );
    const routes = wizardRoutes(reportId);
    localizedPushHistory(routes.generateReport);
    return false;
  }

  render() {
    const {
      report,
      date,
    } = this.props;
    return (
      // eslint-disable-next-line jsx-a11y/anchor-is-valid
      <a
        href="#"
        onClick={(event) => {
          event.preventDefault();
          this.navigate(report, date);
        }}
      >{this.props.children}
      </a>
    );
  }
}

const mapStateToProps = state => ({ selectionCriteria: getSelectionCriteria(state) });

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    reportClearData,
    reportLoadData,
    dayPeriodSelected,
  }, dispatch);

ReportNavigationLink.propTypes = {
  report: PropTypes.string,
  date: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.element,
  ]),
  selectionCriteria: PropTypes.objectOf(PropTypes.shape),
  reportLoadData: PropTypes.func,
  dayPeriodSelected: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(ReportNavigationLink);
